import { render, staticRenderFns } from "./Technique.vue?vue&type=template&id=276f9048&scoped=true&"
import script from "./Technique.vue?vue&type=script&lang=js&"
export * from "./Technique.vue?vue&type=script&lang=js&"
import style0 from "./Technique.vue?vue&type=style&index=0&id=276f9048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f9048",
  null
  
)

export default component.exports